import { Component } from '@angular/core';
import { SearchComponent } from './search/search.component';
import { MenuComponent } from './menu/menu.component';
import { Subscription } from 'rxjs';
import { ViewersService } from '../../services/viewers.service';
import { SelectedNodeComponent } from './selected-node/selected-node.component';
import { NeighborsComponent } from './neighbors/neighbors.component';

@Component({
  selector: 'app-topbar',
  imports: [SearchComponent, MenuComponent, SelectedNodeComponent, NeighborsComponent],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.css'
})
export class TopbarComponent {
  private subscriptions: Subscription[] = [];
  public currentMap!: 'topview' | 'seatmap';
  public is3dView!: boolean;

  constructor(
    private readonly viewersService: ViewersService
  ) { }

  ngOnInit(): void {
    this.updateViewStep();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private updateViewStep(): void {
    // Get 3D View status
    const is3d = this.viewersService.is3dView.subscribe((is3d: boolean) => {
      this.is3dView = is3d;
    });
    // Get Map View status
    const current = this.viewersService.currentMap.subscribe((current: 'topview' | 'seatmap') => {
      // console.log('currentMap', current);
      this.currentMap = current;
    });
    this.subscriptions.push(is3d, current);
  }

}
